import React from "react";
import { formatPhoneInput } from "../../FormCard";
import { inCls, Field } from "./shared";

export default function AddressStep({ data, onChange, firstFieldRef }) {
  const set = (k) => (e) => onChange({ ...data, [k]: e.target.value });
  return (
    <>
      <Field id="onb-address" label="Adresse" required>
        <input id="onb-address" ref={firstFieldRef} type="text" value={data.address || ""} onChange={set("address")} className={inCls} />
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field id="onb-postal" label="Code postal" required>
          <input id="onb-postal" type="text" value={data.postal_code || ""} onChange={set("postal_code")} className={inCls} />
        </Field>
        <Field id="onb-city" label="Ville" required>
          <input id="onb-city" type="text" value={data.city || ""} onChange={set("city")} className={inCls} />
        </Field>
      </div>
      <Field id="onb-country" label="Pays" required>
        <input id="onb-country" type="text" value={data.country || ""} onChange={set("country")} className={inCls} />
      </Field>
      <Field id="onb-phone" label="Téléphone (gestion de projet)">
        <input id="onb-phone" type="tel" inputMode="tel" value={data.company_phone || ""}
          onChange={(e) => onChange({ ...data, company_phone: formatPhoneInput(e.target.value) })} className={inCls} />
      </Field>
    </>
  );
}
